const classExists = (elem) => {
  if (typeof elem === "undefined" && elem === null) {
    return;
  }
};

module.exports = { classExists };
